/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_CuisineInputs */

const en_editor_cuisine = /** @type {(inputs: Editor_CuisineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuisine`)
};

const de_editor_cuisine = /** @type {(inputs: Editor_CuisineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küche`)
};

/**
* | output |
* | --- |
* | "Cuisine" |
*
* @param {Editor_CuisineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_cuisine = /** @type {((inputs?: Editor_CuisineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_CuisineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_cuisine(inputs)
	return en_editor_cuisine(inputs)
});